module.exports = __webpack_public_path__ + "img/1519686929.92ab80f0.jpg";